"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInput = exports.InputWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.InputWrapper = styled_components_1.default.div `
  max-width: 350px;
  height: 40px;
  margin: 0 24px 26px;
  position: relative;

  & > svg {
    position: absolute;
    top: 12px;
    left: 12px;
    cursor: text;
  }
`;
exports.StyledInput = styled_components_1.default.input `
  border: 1px solid #d4d9e8;
  border-radius: 12px;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #657089;
  padding: 12px 48px 12px 36px;

  outline: none;
  width: 100%;
  box-sizing: border-box;
  text-overflow: ellipsis;
`;
//# sourceMappingURL=styles.js.map